import { useMemo } from "react";
import { Inference } from "../../../types/inferences";
import { addSpeciesCount, groupByModelRun, GroupCounts, InferenceCounts, inferenceStatsPerGroup } from "../../../utils/inferenceStats";

function useInfrenceSummary(inferences: Inference[] = []): InferenceCounts & {modelRuns: GroupCounts} {
  return useMemo(() => {
    const inferencesByModelRun = groupByModelRun(inferences);
    const modelRunSummary = inferenceStatsPerGroup(inferencesByModelRun);

    const sceneStats = Object.values(modelRunSummary).reduce((summary, modelRun) => {
      const { validated, species } = modelRun;
      return {
        ...summary,
        validated: summary.validated + validated,
        species: addSpeciesCount(summary.species, species)
      };
    }, {
      count: inferences.length,
      validated: 0,
      species: {}
    });

    return { ...sceneStats, modelRuns: modelRunSummary };
  }, [inferences]);
}

export default useInfrenceSummary;
